module.exports = __webpack_public_path__ + "media/images/search-icon-select-b1dafca0bea25583bbb9829bda97aa07.svg";